<template>
  <div>
    <v-menu offset-y>
      <template #activator="{ on: onMenu }">
        <v-tooltip bottom>
          <template #activator="{ on: onTooltip }">
            <v-btn
              style="height: 35px"
              size="small"
              color="info ml-3 mr-0"
              v-on="{ ...onMenu, ...onTooltip }"
            >
              <v-icon>mdi-gesture-tap</v-icon>
            </v-btn>
          </template>

          <span>Thao tác</span>
        </v-tooltip>
      </template>
      <v-list v-if="actionList && actionList.length">
        <v-list-item
          v-for="(action, index) in actionList"
          :key="`${action.id}_${index}`"
          @click="showModalAction(action.type, action.store)"
        >
          <v-list-item-title>
            {{ action.title }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-dialog v-model="dialog" width="50%">
      <template #activator="{ on: onMenu }">
        <v-tooltip bottom>
          <template #activator="{ on: onTooltip }">
            <v-btn
              color="primary mx-3"
              style="height: 35px"
              size="small"
              dark
              v-on="{ ...onMenu, ...onTooltip }"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>

          <span>Tạo short link</span>
        </v-tooltip>
      </template>
      <ShortLink
        :linkDetailByID="linkDetailByID"
        @close="closeDialog"
        @updateList="updateList"
        :listDomain="listDomain"
      />
    </v-dialog>
    <v-menu
      offset-y
      v-model="openRowMenu"
      bottom
      content-class="no-contain overflow-visible menu-filter-form-allotment"
      :close-on-content-click="false"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          color="primary"
          style="height: 35px"
          size="small"
          :disabled="loadingFilter"
          v-on="on"
        >
          <span>Tìm kiếm</span>
          <v-icon
            v-if="!loadingFilter"
            style="margin-left: 10px; margin-right: -20px"
            >mdi-chevron-down</v-icon
          >
          <v-progress-circular
            v-else
            style="margin-left: 10px; margin-right: -20px"
            indeterminate
            color="white"
          ></v-progress-circular>
        </v-btn>
      </template>
      <filter-form :users="users" @filterData="filterListShortLink($event)" :listDomain="listDomain"/>
    </v-menu>

    <div class="my-5">
      <TableLink
        :rows="listLinks"
        :columns="columns"
        :totalPage="totalPage"
        :page="filterForm.page"
        :selectOption="true"
        :sortField="sortField"
        :lineNumbers="true"
        @sort="sortData"
        @pagination="pagination"
        @onSelectedRowsChange="selectionChanged($event)"
      >
        <template #shortUrl="item">
          <div class="d-flex">
            <a
              :href="item.shortUrl"
              target="_blank"
              :title="item.shortUrl"
              class="my-auto eclip-word"
              >{{ item.shortUrl }}
            </a>
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-btn
                  size="small"
                  rounder
                  icon
                  v-on="on"
                  @click="copyLink(item)"
                >
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </template>
              <span>Copy</span>
            </v-tooltip>
          </div>
        </template>
        <template #originUrl="item">
          <a
            :href="item.originUrl"
            target="_blank"
            class="eclip-word"
            :title="item.originUrl"
            >{{ item.originUrl }}
          </a>
        </template>
        <template #action="item">
          <v-tooltip bottom>
            <template #activator="{ on: onTooltip }">
              <v-btn
                size="small"
                rounder
                icon
                v-on="onTooltip"
                @click="openEditModal(item)"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>

            <span>Sửa short link</span>
          </v-tooltip>
        </template>
      </TableLink>
    </div>
    <modal-change-user
      v-if="showAction.type === 'user'"
      :type="showAction.type"
      :users="users"
      :contacts="selectionChangedLink"
      @close="showAction.type = null"
      @complete="getLinks(filterForm)"
    />
  </div>
</template>

<script>
import FilterForm from "./component/FilterForm.vue";
import ShortLink from "./component/ShortLink.vue";
import ModalChangeUser from './component/ModalChangeUser.vue';
import TableLink from "./component/ShortLinkTable.vue";
import RepositoryFactory from "@/repositories/RepositoryFactory";
import TokenService from "@/helpers/token";
import {userPositions} from "@/helpers/constants";
const ShortLinkRepository = RepositoryFactory.get("short_link");
export default {
  name: "short-link",
  components: {
    ShortLink,
    FilterForm,
    TableLink,
    ModalChangeUser,
  },
  data() {
    return {
      dialog: false,
      openRowMenu: false,
      filterForm: {
        sortClicks: null,
        sortCreatedAt: "desc",
        page: 1,
        limit: 20,
      },
      users: [],
      sortField: {
        createdAt: "desc",
        clicks: null,
      },
      columns: [
        {
          label: "Người tạo",
          field: "createdBy.fullName",
        },
        {
          label: "Người phụ trách",
          field: "personIncharge.fullName"
        },
        {
          label: "Tên miền",
          field: "domain",
        },
        {
          label: "Số lần click",
          field: "clicks",
          tdClass: "text-right",
          sort: true,
          thWidth: "165px",
        },
        {
          label: "Link gốc",
          field: "originUrl",
          customRow: true,
          thWidth: "450px",
        },
        {
          label: "Link rút gọn",
          field: "shortUrl",
          customRow: true,
          thWidth: "450px",
        },
        {
          label: "Thời gian tạo",
          field: "createdAt",
          sort: true,
          type: "date",
          format: "YYYY-MM-DD HH:mm",
        },
        {
          label: "Thao tác",
          field: "actions",
          thWidth: "100px",
          tdClass: "text-center",
        },
      ],
      listLinks: [],
      loadingFilter: false,
      totalPage: 0,
      linkDetailByID: null,
      selectionChangedLink: [],
      showAction:{
        type:null
      },
      usersContactAdvise: [],
      userPositions,
      listDomain: [],
    };
  },
  created() {
    this.getLinks(this.filterForm);
    this.getListNPT();
    this.getListDomain();
  },
  computed: {
    isLeaderPosition() {
      const user = TokenService.getPosition()
      return user === this.userPositions.LEAD
    },
    actionList() {
      const actionList = []
      if(this.isLeaderPosition) {
        actionList.push({ title: 'Chuyển người phụ trách', type: 'user', store: 'all' })
      }
      return actionList;
    },
  },
  watch: {
    dialog(val) {
      if(!val) {
        this.linkDetailByID = null;
      } 
    },
  },
  methods: {
    async getListDomain() {
      const res = await ShortLinkRepository.getListDomain();
      if (res.success) {
        this.listDomain = res.data;
      }
    },
    updateList() {
      this.getLinks(this.filterForm);
    },
    copyLink(item) {
      navigator.clipboard.writeText(item.shortUrl).then(
        () => {
          this.$swal({
            type: "success",
            icon: "success",
            showConfirmButton: false,
            toast: true,
            timer: 1000,
            title: "Sao chép thành công!",
            position: "top",
          });
        },
        (err) => {
          this.$swal({
            type: "error",
            icon: "error",
            title: "Sao chép thất bại!",
            toast: true,
            showConfirmButton: false,
            timer: 1000,
            position: "top",
          });
        }
      );
    },
    pagination(page) {
      this.filterForm.page = page;
      this.getLinks(this.filterForm);
    },
    filterListShortLink(params) {
      this.openRowMenu = false;
      this.filterForm.page = 1;
      this.filterForm = params;
      this.getLinks(this.filterForm);
    },
    async getLinks(params = null) {
      try {
        const loading = this.$loading.show();
        const response = await ShortLinkRepository.list(params);
        loading.hide();
        if (response && response.data) {
          this.listLinks = response.data;
          this.totalPage = this.setNumberPage(response.totalItem);
        }
        if (response && response.error) {
          this.$swal({
            type: "error",
            icon: "error",
            title:
              response && response.error
                ? response.message
                : "Có lỗi xảy ra, vui lòng thử lại!",
            toast: true,
            showConfirmButton: false,
            timer: 1000,
            position: "top",
          });
        }
      } catch (error) {}
    },
    setNumberPage(num) {
      return num % 20 === 0
        ? Math.floor(num / 20) === 0
          ? 1
          : Math.floor(num / 20)
        : Math.floor(num / 20) + 1;
    },
    async getListNPT() {
      this.loadingFilter = true;
      const idUser = TokenService.getId()
      const res = await ShortLinkRepository.listNPT(null,idUser);
      if (res.data) {
        this.loadingFilter = false;
        this.users = res.data;
      } else {
        this.loadingFilter = false;
        this.$swal({
          title: "Lỗi!",
          text: _.get(res, "message", ""),
        });
      }
    },
    sortData(field) {
      this.filterForm.page = 1;
      if (this.sortField[`${field}`] === null) {
        this.sortField[`${field}`] = "desc";
      }
      this.sortField[`${field}`] =
        this.sortField[`${field}`] === "desc" ? "asc" : "desc";
      this.filterForm[`sort${this.jsUcfirst(field)}`] =
        this.sortField[`${field}`];
      Object.keys(this.sortField).forEach((key) => {
        if (key !== field) {
          this.filterForm[`sort${this.jsUcfirst(key)}`] = null;
          this.sortField[`${key}`] = null;
        }
      });
      this.getLinks(this.filterForm);
    },
    jsUcfirst(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    closeDialog() {
      this.dialog = false;
      this.linkDetailByID = null;
    },
    openEditModal(data) {
      this.dialog = true;
      this.linkDetailByID = data;
    },
    selectionChanged(data) {
      this.selectionChangedLink = data;
    },
    showModalAction(modalType, store = 'all') {
      if ( !this.selectionChangedLink.length ) {
         return this.$swal({
          title: 'Lỗi !',
          text: 'Vui lòng chọn link cần update !!!'
        });
      }
      if ( modalType === 'user') {
        this.showAction.type = modalType
      }
    },
  },
};
</script>

<style scoped>
.menu-filter-form-allotment {
  background: white;
  width: 70% !important;
}
.eclip-word {
  display: inline-block;
  width: 400px;
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
}
</style>